import React from "react";

/**
 * The assistant's presence — aura, two counter-rotating rings, breathing core.
 * Design C, approved by Nick 2026-10-21.
 *
 * THE STATE IS REAL, OR IT IS IDLE
 * ================================
 * Three states, and each one is driven by something the surface actually
 * knows:
 *
 *   idle      nothing in flight
 *   thinking  a turn has been sent and the reply has not come back
 *   replying  a reply has arrived and is being revealed
 *
 * There is no fourth "online" state, for the same reason the dock has never
 * had a green dot: there is no liveness signal behind one. An orb that spins
 * faster when nothing is happening is a decoration pretending to be an
 * instrument.
 *
 * WHAT "REPLYING" IS, PRECISELY
 * =============================
 * The backend returns a complete reply in one piece — it does not stream.
 * The reveal animation and the caret are PRESENTATION of text already
 * received, not evidence of live generation. That distinction is recorded
 * here because it is exactly the kind of thing a reader would otherwise
 * assume the wrong way round, and because making it true would mean changing
 * the transport, not this component.
 *
 * MOTION IS OPTIONAL
 * ==================
 * Every animation is disabled under `prefers-reduced-motion`, in the
 * stylesheet rather than here, so the component has one code path and the
 * accessibility promise cannot be broken by a prop.
 */
export default function DonnaOrb({ state = "idle", size = 240, className = "" }) {
  const cls = state === "thinking" ? "st-thinking"
    : state === "replying" ? "st-speaking"
      : "";
  return (
    <div
      className={`ea-orb-stage ${cls} ${className}`.trim()}
      style={{ width: size, height: size }}
      data-state={state}
      aria-hidden="true"
    >
      <div className="ea-orb-aura" />
      <div className="ea-orb-ring" />
      <div className="ea-orb-ring2" />
      <div className="ea-orb-core" />
    </div>
  );
}

/** The 28px orb that marks one of Donna's turns. Same core, no rings. */
export function MiniOrb() {
  return <div className="ea-mini-orb" aria-hidden="true" />;
}

/** The three sound-wave bars shown beside her status while she is replying. */
export function WaveBars() {
  return (
    <span className="ea-wave" aria-hidden="true">
      <span className="ea-wave-bar" />
      <span className="ea-wave-bar" />
      <span className="ea-wave-bar" />
    </span>
  );
}
